import { useI18n } from "../i18n/LanguageContext";
import { IMAGES, GALLERY_ORDER } from "../data/mediaAssets";
import { useReveal } from "../hooks/useReveal";

const Gallery = () => {
    const { t } = useI18n();
    const ref = useReveal();

    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="bg-brand-navy py-24 md:py-32 relative overflow-hidden"
        >
            <div className="absolute inset-0 opacity-10 pointer-events-none">
                <div className="absolute top-1/4 -left-40 w-96 h-96 bg-brand-gold rounded-full blur-3xl" />
                <div className="absolute bottom-1/4 -right-40 w-96 h-96 bg-brand-gold rounded-full blur-3xl" />
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
                <div className="text-center mb-16 md:mb-20 max-w-3xl mx-auto">
                    <p className="font-sans text-brand-gold text-xs uppercase tracking-[0.5em] mb-5">
                        — {t.gallery.eyebrow}
                    </p>
                    <h2
                        data-testid="gallery-title"
                        className="font-serif text-white text-4xl md:text-5xl lg:text-6xl leading-tight"
                    >
                        {t.gallery.title}
                    </h2>
                    <p className="mt-6 font-sans text-white/70">{t.gallery.intro}</p>
                </div>

                <div
                    ref={ref}
                    className="reveal grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4"
                >
                    {GALLERY_ORDER.map((item, i) => (
                        <div
                            key={item.key}
                            data-testid={`gallery-item-${item.key}`}
                            className={`group relative overflow-hidden cursor-pointer ${
                                i === 0 || i === 5 ? "md:col-span-1 md:row-span-2 aspect-[3/4] md:aspect-auto" : "aspect-square"
                            }`}
                        >
                            <img
                                src={IMAGES[item.key]}
                                alt={item.label}
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-brand-navy-deep/90 via-brand-navy-deep/20 to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
                            <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                                <div className="h-px w-8 bg-brand-gold mb-2" />
                                <p className="font-serif text-white text-base md:text-lg leading-tight">
                                    {item.label}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Gallery;
